import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    collapsedText: String,
    expandedText: String,
  };

  toggle(event) {
    event.preventDefault();
    const toggleLink = event.currentTarget;
    const collapseSelector = toggleLink.dataset.target; 
    if (!collapseSelector) return;
  
    const $collapseEls = $(collapseSelector);
  
    $collapseEls.each((_, el) => {
      if (!$(el).data("boundToggleEvents")) {
        $(el).on("shown.bs.collapse", () => {
          this.updateToggles(collapseSelector, true);
        });
        $(el).on("hidden.bs.collapse", () => {
          this.updateToggles(collapseSelector, false);
        });
        $(el).data("boundToggleEvents", true);
      }
    });
  
    $collapseEls.collapse("toggle");
  }
  
  updateToggles(collapseSelector, expanded) {
    const $toggleLinks = $(`[data-target="${collapseSelector}"]`);
    $toggleLinks.each((_, link) => {
      const $text = $(link).find('[data-toggle-collapse-text-target="text"]');
      const $iconCollapsed = $(link).find('[data-toggle-collapse-text-target="iconCollapsed"]');
      const $iconExpanded = $(link).find('[data-toggle-collapse-text-target="iconExpanded"]');

      if (expanded) {
        $text.text(this.expandedTextValue);
        $iconCollapsed.addClass("d-none");
        $iconExpanded.removeClass("d-none");
      } else {
        $text.text(this.collapsedTextValue);
        $iconCollapsed.removeClass("d-none");
        $iconExpanded.addClass("d-none");
      }
    });
  }
}